import {useCallback, useEffect, useRef, useState} from 'react';

import {platform} from '../platform';
import {isDefined} from '../typecheck';

export const useIsKeyboardOpen = (
  defaultValue = false,
  minKeyboardHeight = 300,
) => {
  const [isOpen, setIsOpen] = useState(defaultValue);
  const isOpenRef = useRef(isOpen);

  const listener = useCallback(() => {
    if (isDefined(window.visualViewport)) {
      const newState =
        window.screen.height - minKeyboardHeight > window.visualViewport.height;

      setIsOpen(newState);
    }
  }, [minKeyboardHeight]);

  useEffect(() => {
    isOpenRef.current = isOpen;
  }, [isOpen]);

  useEffect(() => {
    if (isDefined(window.visualViewport) && platform.isMobileBrowser) {
      window.visualViewport.addEventListener('resize', listener);
    }

    return () => {
      if (isDefined(window.visualViewport) && platform.isMobileBrowser) {
        window.visualViewport.removeEventListener('resize', listener);
      }
    };
  }, [listener]);

  return {isKeyboardOpen: isOpen, isKeyboardOpenRef: isOpenRef};
};
